import React from 'react';

import Provider from './Provider';

export function wrapWithProvider({element}: any) {
  return <Provider>{element}</Provider>;
}

export default wrapWithProvider;
